<template>
    <Swiper class="location-carousel w-full h-full" v-bind="standardCarouselConfig">
        <SwiperSlide v-for="item in items" :key="item.image.id">
            <img :src="item.image.url" :alt="item.image.alt" class="size-full object-cover" />
        </SwiperSlide>

        <template #container-start>
            <button type="button" class="carousel-nav carousel-nav-prev">
                <ArrowRightIcon class="size-5 rotate-180" />
            </button>
            <button type="button" class="carousel-nav carousel-nav-next">
                <ArrowRightIcon class="size-5" />
            </button>
        </template>
    </Swiper>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import ArrowRightIcon from '../../../images/icons/arrow-right.svg';
import { useCarousel } from '../../composables/carousel';

defineProps({ items: { type: Array, default: () => [] } });

const { standardCarouselConfig } = useCarousel();
</script>
